import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Segment,
  Grid,
  Accordion,
  Icon,
  Button,
  Table,
} from "semantic-ui-react";
import { isMobile } from "react-device-detect";
import _ from "lodash";
import { parseString } from "xml2js";
import axios from "axios";
import settings, { getApiHost } from "../../settings";
import AppMenu from "../../components/pages/AppMenu";
import SearchSubTypes from "./SearchSubTypes";
import NewSearchComponent from "../common/NewSearchComponent";
import HomeValueAndIncomeComponent from "../common/HomeValueAndIncomeComponent";
import getComponentByName from "../searchresults/SearchResultComponentFactory";
import getReportComponentByName from "../../components/reports/SearchReportComponentFactory";
import { encodeUrl } from "../../utils/urlHelper";
import SearchForms from "../searches/SearchForms";
import { expireSession, renewUserToken } from "../../actions/auth";
import api from "../../api";
import "../../App.css";
import { getErrorMessage } from "../messages/errorMessages";
import {
  addItemToProgress,
  removeItemFromProgress,
  clearProgressList,
} from "../../actions/progressList";
import { setApiCancelToken } from "../../actions/apiCancelSource";
import UserInterruption from "./UserInterruption";
import { ERR_NO_RECORDS_FOUND } from "../../ErrorMessages";
import SearchLeftForms from "./SearchLeftForms";
import getNoResult from "../searchresults/NoResult";

class SearchHistoryComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      activeIndex: 0,
      savedResultID: "",
      searchTypeIndex: 0,
      user: {},
      showDialog: false,
      showNewSearchDialog: false,
      searchText: "",
      popupType: "",
      homeType: "",
      searchResultData: null,
      resultComponent: null,
      selectedRows: [],
      reportComponent: null,
      resultCheckAll: false,
      resultItemState: [],
      resultRecordCount: 0,
      enableReport: false,
      popupMenuData: [],
      showSubTypes: true,
      subMenuItem: null,
      subMenuItems: [],
      leftMenuItem: null,
      leftMenuItems: [],
      searchLoadError: null,
      newFormsData: [],
      report: null,
      searchData: [],
      previewData: [],
      showCancelSearch: false,
      cancelSource: null,
      searchFormsData: [],
      cancelSources: [],
      canSources: {},
      selectedFormIndex: 0,
      currentReportId: undefined,
      currentReportRemainingCount: undefined
    };
  }

  componentDidMount = () => {
    this.updateStateFromProps(this.props);
    // const dat = Date.now();
    // localStorage.setItem("expires", dat + 30 * 60 * 60 * 1000);
    localStorage.setItem("sectok", "");
  };

  // eslint-disable-next-line no-unused-vars
  componentWillReceiveProps = (nextProps) => {
    renewUserToken();
  };

  componentWillUnmount() {
    this.isCompMounted = false;
  }

  onSearchTypeChanged = (e, tabIndex, menuId) => {
    if (tabIndex >= 0) {
      const { uiData } = this.props;
      this.setState({ searchTypeIndex: tabIndex, selectedFormIndex: 0 });
      const leftMenu = _.find(
        uiData.Menus.MenuItems,
        (a) => a.MenuId === menuId
      );
      if (leftMenu === undefined) {
        this.setState({
          searchLoadError: "Invalid menu selection...",
        });
        return;
      }
      const subMenu = _.find(
        uiData.Menus.MenuItems,
        (a) => a.MenuId === leftMenu.ParentId
      );
      if (subMenu === undefined) {
        this.setState({
          searchLoadError: "The selected page not found",
        });
        return;
      }
      const mainMenu = _.find(
        uiData.Menus.MenuItems,
        (a) => a.MenuId === subMenu.ParentId
      );
      if (mainMenu === undefined) {
        this.setState({
          searchLoadError: "The selected page not found",
        });
        return;
      }
      this.setState({currentReportId: undefined, currentReportRemainingCount: undefined});
      this.props.history.push(
        `/search/${encodeUrl(mainMenu.MenuTitle)}/${encodeUrl(
          subMenu.MenuTitle
        )}/${encodeUrl(leftMenu.MenuTitle)}/${leftMenu.MenuId}`
      );
    }
  };

  onFormDataChange = (formId, formData, currentControlName) => {
    const searchFormsData = this.state.searchFormsData;
    if (currentControlName !== undefined) {
      const rules = _.filter(
        Object.keys(settings.controlRules),
        (rule) => rule === currentControlName
      );
      if (rules !== undefined && rules.length > 0) {
        _.forEach(settings.controlRules[rules[0]], (values, key) => {
          if (key === "remove") {
            _.forEach(values, (value) => {
              delete formData[value];
            });
          } else if (key === "hide") {
            if (formData[currentControlName] === true) {
              _.forEach(values, (value) => {
                delete formData[`hide_${value}`];
              });
            } else {
              _.forEach(values, (value) => {
                formData[`hide_${value}`] = true;
              });
            }
          }
        });
      }
    }

    searchFormsData[formId] = formData;
    this.setState({ searchFormsData, selectedFormId: formId });
  };

  getMenuItems = (props, data) => {
    const uiData = props.uiData;
    let historyReportId = parseInt(localStorage.getItem("historyReportId"), 10);
    if (data) {
      historyReportId = data.reportID;
    }
    if (!historyReportId) historyReportId = this.state.report.ReportID;
    // if (!historyReportId) historyReportId = parseInt(historyReportId, 10);
    const report = _.find(
      uiData.Reports,
      (a) => a.ReportID === historyReportId
    );
    if (!report) return null;
    let historyMenuItemsByReportId = _.find(
      uiData.Menus.MenuItems,
      (m) => m.ReportId === historyReportId
    );
    if (report.ReportCategory !== "Search") {
      historyMenuItemsByReportId = _.find(
        uiData.Menus.MenuItems,
        (m) => m.ReportIds !== null && m.ReportIds.includes(historyReportId)
      );
    }
    if (historyMenuItemsByReportId) {
      const leftMenuItem = historyMenuItemsByReportId;
      const subMenuItem = _.find(
        uiData.Menus.MenuItems,
        (m) => m.MenuId === leftMenuItem.ParentId
      );
      const subMenuItems = _.filter(
        uiData.Menus.MenuItems,
        (a) => a.ParentId === subMenuItem.ParentId
      );
      const leftMenuItems = _.filter(
        uiData.Menus.MenuItems,
        (a) => a.ParentId === leftMenuItem.ParentId
      );
      const newFormsData = [];
      _.forEach(leftMenuItem.FormIds, (formId) => {
        const formControls = _.filter(
          uiData.FormData,
          (a) => a.FormId === formId
        );
        newFormsData.push(formControls);
      });
      return { leftMenuItems, subMenuItems, leftMenuItem, subMenuItem, report };
    }
    return {};
  };

  userInterruption = (sourceName, cancelSource) => {
    const canSources = this.state.cancelSources;
    const canSrcs = Object.keys(canSources);
    if (canSrcs.find((a) => a === sourceName)) {
      delete canSources[sourceName];
    }
    canSources[sourceName] = cancelSource;
    const cancelSources = this.state.cancelSources;
    cancelSources.push(cancelSource);
    this.setState({ canSources, cancelSources });
  };

  workerCompleted = (sourceName) => {
    const canSources = this.state.cancelSources;
    const canSrcs = Object.keys(canSources);
    if (canSrcs.find((a) => a === sourceName)) {
      delete canSources[sourceName];
    }
    const cancelSources = this.state.cancelSources;
    cancelSources.pop();
    this.setState({ canSources, cancelSources });
  };

  handleCancelRequest = () => {
    if (this.state.cancelSources.length > 0) {
      for (let i = 0; i < this.state.cancelSources.length; i += 1) {
        this.state.cancelSources[i].cancel("User cancelled");
      }
      this.setState({ cancelSources: [] });
    }
  };

  isCompMounted = false;

  updateStateFromProps = (props) => {
    let historyReportId = parseInt(localStorage.getItem("historyReportId"), 10);
    const historyCriteria = localStorage.getItem("historyCriteria");
    const xmlId = localStorage.getItem("xmlId");
    let parentXmlId;
    let internalID = -1;
    if (historyCriteria && historyCriteria.indexOf("searchID") !== -1) {
      const critTokens = historyCriteria.split("_");
      if (critTokens.length > 2) {
        parentXmlId = critTokens[2];

        if (critTokens.length > 3) {
          internalID = critTokens[3];
        }
        if (critTokens.length > 4 && critTokens[4] !== "") {
          historyReportId = parseInt(critTokens[4], 10);
        }
      }
    }
    const { uiData } = props;
    const report = _.find(
      uiData.Reports,
      (a) => a.ReportID === historyReportId
    );
    if (!report) return null;
    let historyMenuItemsByReportId = _.find(
      uiData.Menus.MenuItems,
      (m) => m.ReportId === historyReportId
    );
    if (report.ReportCategory !== "Search") {
      historyMenuItemsByReportId = _.find(
        uiData.Menus.MenuItems,
        (m) => m.ReportIds !== null && m.ReportIds.includes(historyReportId)
      );
    }

    if (historyMenuItemsByReportId) {
      const leftMenuItem = historyMenuItemsByReportId;
      const subMenuItem = _.find(
        uiData.Menus.MenuItems,
        (m) => m.MenuId === leftMenuItem.ParentId
      );
      const mainMenuItem = _.find(
        uiData.Menus.MenuItems,
        (m) => m.MenuId === subMenuItem.ParentId
      );
      const subMenuItems = _.filter(
        uiData.Menus.MenuItems,
        (a) => a.ParentId === subMenuItem.ParentId
      );
      const leftMenuItems = _.filter(
        uiData.Menus.MenuItems,
        (a) => a.ParentId === leftMenuItem.ParentId
      );
      const newFormsData = [];
      _.forEach(leftMenuItem.FormIds, (formId) => {
        const formControls = _.filter(
          uiData.FormData,
          (a) => a.FormId === formId
        );
        newFormsData.push(formControls);
      });
      const searchFormsData = [];
      _.forEach(newFormsData, (formsData) => {
        const formId = formsData[0].FormId;
        const formData = [];
        formData.formID = formId;
        searchFormsData[`Form_${formId}`] = formData;
      });
      this.isCompMounted = true;
      let searchFormId;
      api.lp
        .getActivityFieldValues({
          activityId: parseInt(parentXmlId || xmlId, 10),
          userCode: this.props.user.userID,
          appname: settings.appName,
          token: localStorage.getItem("sessionID"),
        })
        .then((res) => {
          if (
            this.isCompMounted &&
            res.data.Status === "OK" &&
            res.data.Data &&
            res.data.Data.length > 0
          ) {
            const searchFormField = _.find(
              res.data.Data,
              (p) => p.FieldId === 0
            );

            if (searchFormField) {
              // const searchFormsData = this.state.searchFormsData;
              searchFormId = searchFormField.FieldValue;
              const selectedForm =
                searchFormsData[`Form_${searchFormField.FieldValue}`];
              const formControls = _.filter(
                uiData.FormData,
                (a) => a.FormId === parseInt(searchFormField.FieldValue, 10)
              );
              let selectedFormId;
              _.forEach(res.data.Data, (fv) => {
                if (fv.FieldId !== 0) {
                  const control = _.find(
                    formControls,
                    (fc) => fc.FieldId === fv.FieldId
                  );
                  if (control) {
                    if (control.FieldName === "dob") {
                      const dobTokens = fv.FieldValue.split("/");
                      if (dobTokens.length > 2) {
                        selectedForm.dobYear = parseInt(dobTokens[2], 10);
                      }
                      if (dobTokens.length > 1) {
                        selectedForm.dobDay = parseInt(dobTokens[1], 10);
                      }
                      selectedForm.dobMonth = parseInt(dobTokens[0], 10);
                      selectedForm[control.FieldName] = dobTokens.join("%252F");
                    } else {
                      selectedForm[control.FieldName] = fv.FieldValue;
                    }
                  }
                } else {
                  selectedFormId = `Form_${fv.FieldValue}`;
                }
              });
              this.setState({ searchFormsData, selectedFormId });
            }
          }
        })
        .catch((err) => console.log("load case charges error - ", err))
        .then(() => {
          // const searchFormsData = [];
          let selectedFormIndex = 0;
          const { selectedFormId } = this.state;
          let selFormId;
          if (selectedFormId) {
            const tokens = selectedFormId.split("Form_");
            if (tokens[1] !== "undefined") {
              selFormId = parseInt(tokens[1], 10);
            }
          }
          _.forEach(newFormsData, (formsData, index) => {
            const formId = formsData[0].FormId;
            const formData = [];
            formData.formID = formId;
            if (selFormId !== undefined && selFormId === formId) {
              selectedFormIndex = index;
            }
            if (
              !searchFormsData[`Form_${formId}`] ||
              Object.keys(searchFormsData[`Form_${formId}`]).length < 2
            ) {
              searchFormsData[`Form_${formId}`] = formData;
            }
          });
          const days = localStorage.getItem("days");
          const showSearchOrReport = !(
            days === "31" ||
            (report.ReportCategory === "Search" &&
              parseInt(localStorage.actCode, 10) < 1)
          );
          const isSearch = report.ReportCategory === "Search";
          this.setState({
            mainMenuItem,
            subMenuItem,
            subMenuItems,
            leftMenuItem,
            leftMenuItems,
            newFormsData,
            searchFormsData,
            report,
            searchTypeIndex: _.findIndex(
              leftMenuItems,
              (a) => a.MenuId === leftMenuItem.MenuId
            ),
            activeIndex: 0,
            showSubTypes: true,
            resultComponent: null,
            reportComponent: null,
            selectedFormIndex,
          });
          const data = {
            reportID: historyReportId,
            xmlid: xmlId,
            formID: searchFormId,
          };
          if (showSearchOrReport) {
            if (isSearch) {
              if (internalID !== -1) data.internalID = internalID;
              this.showResults(this, data);
              // } else if (report.ReportCategory === "Report") {
              //     this.showResults(this, data);
            } else {
              const reportApiName = "aReport";
              data.optReportType = report.ReportOpt;
              switch (report.ReportOpt) {
                case "person":
                case "compplus":
                case "comp":
                case "residential":
                case "ssnverification":
                case "persummary":
                case "relationships": {
                  if (historyCriteria.indexOf("searchID") !== -1) {
                    const critTokens = historyCriteria.split("_");
                    data.internalID = 1;
                    if (critTokens.length > 2) {
                      data.savedResultID = critTokens[2];
                      const savedResId = parseInt(critTokens[2], 10);
                      if (!savedResId) {
                        data.savedResultID = `${historyReportId}_${critTokens[2]}`;
                      }
                    }
                    if (critTokens.length > 3) {
                      data.internalID = critTokens[3];
                    }
                  }
                  if (report.ReportOpt === "relationships") {
                    data.requestedSection = report.ReportOpt;
                  }
                  break;
                }
                default: {
                  console.log("default case");
                }
              }
              this.showReport(undefined, reportApiName, {menuId: leftMenuItem.MenuId}, data, xmlId);
            }
          }
        });
    }
    return null;
  };

  updateFormDataValue = (newFormData, storageKey) => {
    if (
      this.state.formData === undefined ||
      localStorage.getItem(storageKey) === undefined ||
      newFormData === undefined ||
      newFormData.formControls === undefined
    )
      return;
    const prevData = JSON.parse(localStorage.getItem(storageKey));
    if (prevData === undefined || prevData === null) {
      return;
    }
    const dataKeys = Object.keys(prevData);

    _.forEach(newFormData.formControls, (newCont) => {
      if (_.find(dataKeys, (a) => a === newCont.controlName) !== undefined) {
        newCont.value = prevData[newCont.controlName];
      }
    });
    localStorage.removeItem(storageKey);
  };

  submitSearch = (e, data) => {
    localStorage.previewMenuItem = this.customArryToJson({
      FormID: data.formID,
    });
    localStorage.searchPreviewData = this.customArryToJson(data);
    localStorage.searchImmidiate = "true";
    const { mainMenuItem, subMenuItem, leftMenuItem } = this.state;
    this.props.history.push(
      `/search/${mainMenuItem.MenuTitle}/${subMenuItem.MenuTitle}/${leftMenuItem.MenuTitle}/${leftMenuItem.MenuId}`
    );
  };

  updateRemainingSearchCount = (reportId) => {
    const payload = { reportId, appName: settings.appName };
    api.lp.getRemainingSearchCount(payload)
      .then((res) => {
        if (res && res.status === 200 && res.data && res.data.Message === "success") {
          const remainingCount = res.data.Data.RemainingCount;
          if (remainingCount !== -2) {
            const uiData = this.props.uiData;
            const report = _.find(uiData.Reports, r => r.ReportID === reportId);
            if (report) {
              report.NumberRemaining = remainingCount;
              localStorage.searchUiData = JSON.stringify(uiData);
              this.props.uiLoaded(uiData);
              this.setState({currentReportId: reportId, currentReportRemainingCount: remainingCount});
            }
          }
        }
      });
  }

  showResults = (e, data, cached) => {
    renewUserToken();
    const menuItems = this.getMenuItems(this.props, data);
    if (menuItems === null) return;
    const { leftMenuItem, subMenuItem, report } = menuItems;
    const cancelToken = axios.CancelToken;
    const cancelSource = cancelToken.source();
    this.userInterruption("searchhistory", cancelSource);
    this.props.addItemToProgress({ name: "searchhistory" });
    this.props.setApiCancelSource({ type: 2, source: cancelSource });
    this.setState({
      loading: true,
      enableReport: false,
      showCancelSearch: true,
      cancelSource,
      resultComponent: null,
    });
    const payload = {};
    payload.userID = this.props.user.userid;
    _.forEach(Object.keys(data), (key) => {
      payload[key] = data[key];
    });
    if (!payload.radius) {
      payload.radius = 0;
    }
    if (cached) {
      payload.cached = cached;
      delete payload.updateAddress;
    }
    payload.searchBy = leftMenuItem.ParentId;
    payload.searchType = subMenuItem.ParentId;
    payload.reportID = report.ReportID;
    payload.sectok = localStorage.getItem("sectok");
    payload.sserver = settings.appName;
    payload.sessionID = localStorage.getItem("sessionID");
    payload.caseNumber =
      localStorage.getItem("selectedFolderCode") === undefined ||
      localStorage.getItem("selectedFolderCode") === "-1" ||
      localStorage.getItem("selectedFolderCode") === "-2"
        ? ""
        : localStorage.getItem("selectedFolderCode");
    axios
      .post(`${getApiHost(settings.env)}/aSearch.aspx`, payload, {
        cancelToken: cancelSource.token,
      })
      .then((res) => {
        if (!res || !res.data || res.data === "") {
          this.setState({
            activeIndex: 1,
            resultComponent: getNoResult(),
            loading: false,
            resultRecordCount: 0,
            enableReport: false,
            showSubTypes: true,
            showCancelSearch: false,
            cancelSource: null,
            reportComponent: null,
          });
          this.props.workerCompleted("searchhistory", cancelSource);
          setTimeout(() => {
            this.props.removeItemFromProgress({ name: "searchhistory" });
          }, 500);
          this.updateRemainingSearchCount(report.ReportID);
          return;
        }
        parseString(res.data, { async: false }, (err, result) => {
          const root = Object.keys(result)[0];
          const unhandledError = _.get(result, `${root}.html[0].head[0].title[0]._`);
          const hasError = Object.keys(_.get(result, root))[0] === "error";
          let errorMessage;
          if(unhandledError) errorMessage = "Unable to process, please narrow down search with more criteria."
          if (root === "errors" || hasError) {
            if (hasError)
              localStorage.errorMessage = _.get(
                result,
                `${root}.error[0].errMsg[0]`,
                ""
              );
            else
              localStorage.errorMessage = _.get(
                result,
                `${root}.error[0].errMsg[0]`,
                ""
              );

            errorMessage = getErrorMessage(
              localStorage.errorMessage,
              _.get(result, `${root}.error[0].errMsg[0]`, "")
            );
            const errType = _.get(result, `${root}.error[0].$.errType`);
            if (
              errType === "unauthorized"
            ) {
              this.props.expireSession(errorMessage);
              return;
            }
            if(errType === "emptyactivitydesc") {
              this.setState({
                activeIndex: 1,
                loading: false,
                cancelSource: null,
                errorMessage
              })
              this.props.workerCompleted("search", cancelSource);
              setTimeout(() => {
                this.props.removeItemFromProgress({ name: "search" });
              }, 500);
              return;
            }
          }
          const resultId = _.get(result, `${root}.log[0].actID[0]`);
          let recordCount = _.get(result, `${root}.log[0].actCode[0]`);
          const resultItemState = [];
          if (recordCount !== undefined) {
            recordCount = parseInt(recordCount, 10);
            for (let index = 0; index < recordCount; index += 1) {
              resultItemState[index] = false;
            }
          }
          if ((!errorMessage || errorMessage === "") && recordCount === 0) {
            errorMessage = ERR_NO_RECORDS_FOUND;
          }
          const resultComponent = getComponentByName(
            `${subMenuItem.MenuTitle}/${leftMenuItem.MenuTitle}`,
            result,
            this.handleReportSelection,
            this.state.resultCheckAll,
            resultItemState,
            recordCount,
            this.handleNewSearchClick,
            this.handlePreviewNewSearch,
            this.handleHomeValueClick,
            this.handleMapClick,
            this.handleHomeIncomeClick,
            this.showReport,
            this.printContent,
            this.showResults,
            data,
            {
              reportIds: leftMenuItem.ReportIds,
              menuId: leftMenuItem.MenuId,
              errorMessage,
            }
          );
          this.setState({
            savedResultID: resultId,
            searchResultData: result,
            activeIndex: 1,
            resultComponent,
            loading: false,
            resultItemState,
            resultRecordCount: recordCount,
            enableReport: true,
            showSubTypes: true,
            showCancelSearch: false,
            cancelSource: null,
            reportComponent: null,
          });
          this.workerCompleted("searchhistory");
          setTimeout(() => {
            this.props.removeItemFromProgress({ name: "searchhistory" });
          }, 500);
        });
      })
      .catch((err) => {
        console.log("Error while fetch results", err);
        this.setState({ loading: false });
        if (this.props && this.workerCompleted)
          this.workerCompleted("searchhistory");
        if (this.props && this.props.clearProgressList)
          this.props.clearProgressList();
      });
  };

  clearFormData = (e, data) => {
    const searchFormsData = this.state.searchFormsData;
    searchFormsData[`Form_${data.formID}`] = { formID: data.formID };
    this.setState({ searchFormsData });
  };

  showReport = (reportName, reportApiName, selRow, additionalData, xmlId) => {
    renewUserToken();
    const { leftMenuItem, subMenuItem, report } = this.getMenuItems(this.props);
    let addData = _.cloneDeep(additionalData);
    const cancelToken = axios.CancelToken;
    const cancelSource = cancelToken.source();
    this.userInterruption("reporthistory", cancelSource);
    this.props.addItemToProgress({ name: "reporthistory" });
    this.props.setApiCancelSource({ type: 2, source: cancelSource });
    this.setState({
      loading: true,
      enableReport: false,
      showCancelSearch: true,
      cancelSource,
    });

    if (addData === undefined) {
      addData = {};
    }

    if (addData.internalID === undefined && addData.lookupID === undefined) {
      const internalID =
        selRow !== undefined && selRow !== ""
          ? selRow
          : _.join(this.state.selectedRows, "|");
      addData.internalID = internalID;
      additionalData.internalID = internalID;
      // if (internalID === "") {
      //   this.setState({ loading: false });
      //   return null;
      // }
    }
    if (addData.ignoreReportId) {
      delete addData.ignoreReportId;
    } else if (addData.reportID === undefined) {
      addData.reportID = report.ReportID;
    }

    addData.userID = this.props.user.userid;
    addData.sectok = localStorage.getItem("sectok");
    addData.sserver = settings.appName;
    addData.sessionID = localStorage.getItem("sessionID");

    additionalData.userID = this.props.user.userid;
    additionalData.sectok = localStorage.getItem("sectok");
    additionalData.sserver = settings.appName;
    additionalData.sessionID = localStorage.getItem("sessionID");
    if (leftMenuItem) additionalData.menuId = leftMenuItem.MenuId;

    if (!addData.savedResultID) {
      addData.savedResultID = this.state.savedResultID;
      additionalData.savedResultID = this.state.savedResultID;
    }

    if (xmlId && xmlId !== "") {
      addData.xmlid = xmlId;
      delete addData.savedResultID;
    }

    if (!addData.lookupID) addData.lookupID = "";

    if (reportApiName === undefined || reportApiName === "")
      reportApiName = "criminalReport";
    axios
      .post(`${getApiHost(settings.env)}/${reportApiName}.aspx`, addData, {
        cancelToken: cancelSource.token,
      })
      .then((res) => {
        if (!res || !res.data || res.data === "") {
          this.setState({
            activeIndex: 2,
            reportComponent: getNoResult(),
            loading: false,
            resultRecordCount: 0,
            enableReport: false,
            showSubTypes: true,
            showCancelSearch: false,
            cancelSource: null,
          });
          this.props.workerCompleted("reporthistory", cancelSource);
          setTimeout(() => {
            this.props.removeItemFromProgress({ name: "reporthistory" });
          }, 500);
          return;
        }
        parseString(res.data, { async: false }, (err, result) => {
          const root = Object.keys(result)[0];
          if (root === "errors") {
            const errorMessage = getErrorMessage(
              _.get(result, `${root}.error[0].errMsg[0]`, "")
            );
            const errType = _.get(result, `${root}.error[0].$.errType`);
            if (
              errType === "unauthorized"
            ) {
              localStorage.errorMessage = errorMessage;
              this.props.expireSession(errorMessage);
            }
            if(errType === "emptyactivitydesc") {
              this.setState({
                activeIndex: 2,
                loading: false,
                cancelSource: null,
                errorMessage
              })
              this.props.workerCompleted("report", cancelSource);
              setTimeout(() => {
                this.props.removeItemFromProgress({ name: "report" });
              }, 500);
              return;
            }
          }
          let reportRoot =
            reportName !== undefined && reportName !== ""
              ? reportName
              : `${subMenuItem.MenuTitle}/${leftMenuItem.MenuTitle}`;
          if (additionalData.optReportType === "persummary") {
            reportRoot = "Person/MoreDetails";
          }
          const reportComponent = getReportComponentByName(
            reportRoot,
            result,
            this.handleNewSearchClick,
            this.handleHomeValueClick,
            this.handleMapClick,
            this.handleHomeIncomeClick,
            additionalData,
            this.userInterruption,
            this.showReport,
            this.printContent,
            this.props.history
          );
          this.setState({
            activeIndex: 2,
            reportComponent,
            loading: false,
            showSubTypes: false,
            showCancelSearch: false,
            cancelSource: null,
          });
          this.workerCompleted("reporthistory");
          setTimeout(() => {
            this.props.removeItemFromProgress({ name: "reporthistory" });
          }, 500);
        });
      })
      .catch((err) => {
        console.log("Error while fetch results", err);
        this.setState({ loading: false });
        if (this.props && this.workerCompleted)
          this.workerCompleted("reporthistory");
        if (this.props && this.props.clearProgressList)
          this.props.clearProgressList();
      });

    return null;
  };

  handleReportSelection = (e) => {
    const rows = this.state.selectedRows;
    const row = parseInt(e.target.id, 10);
    if (e.target.checked === true) {
      rows.push(row);
    } else {
      _.remove(rows, (a) => a === row);
    }
    const resultItemState = this.state.resultItemState;
    resultItemState[e.target.id] = e.target.checked;
    const orderedRows = _.orderBy(rows, (v) => v, "asc");
    this.setState({ selectedRows: orderedRows, resultItemState });
  };

  handleClick = (e, titleProps) => {
    const { activeIndex } = this.state;
    const newIndex = activeIndex === titleProps ? -1 : titleProps;
    this.setState({ activeIndex: newIndex, showSubTypes: newIndex < 2 });
  };

  handleHomeValueClick = (e, zip, address) => {
    this.setState({ zip, address, showDialog: true, homeType: "value" });
  };

  popupwindow = (url, title, w, h) => {
    const left = window.width / 2 - w / 2;
    const top = window.height / 2 - h / 2;
    return window.open(
      url,
      title,
      `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${top}, left=${left}`
    );
  };

  handleMapClick = (e, address) => {
    this.popupwindow(
      `https://www.google.com/maps?q=${address}&t=h`,
      "Locateplus Map",
      window.width,
      window.height
    );
  };

  handleHomeIncomeClick = (e, zip, address) => {
    this.setState({ zip, address, showDialog: true, homeType: "income" });
  };

  handleNewSearchClick = (e, type, searchText, data) => {
    this.setState({
      searchText,
      searchData: data,
      showNewSearchDialog: true,
      popupType: type,
    });
  };

  handlePreviewNewSearch = (e, option, data, menuItem) => {
    this.setState({ showNewSearchDialog: false });
    localStorage.searchPreviewData = this.customArryToJson(data);
    localStorage.previewMenuItem = this.customArryToJson(menuItem);
    this.toggleSubtype();
    const resultComponent = getComponentByName("");
    const reportComponent = getReportComponentByName("");
    this.setState({
      previewData: this.customArryToJson(data),
      activeIndex: 0,
      resultComponent,
      reportComponent,
    });
    this.props.history.push(
      `/search/${encodeUrl(option.category)}/${encodeUrl(
        option.groupType
      )}/${encodeUrl(option.value)}/${menuItem.MenuId}`
    );
  };

  handleNewSearchDialogClose = () => {
    this.setState({ showNewSearchDialog: false });
  };

  handleHomeValueClose = () => {
    this.setState({ showDialog: false });
  };

  handleFormChange = (index) => {
    this.setState({ selectedFormIndex: index });
  };

  toggleSubtype = () => {
    this.setState({ showSubTypes: !this.state.showSubTypes });
  };

  customArryToJson = (data) => {
    let str = "";
    _.forEach(Object.keys(data), (key) => {
      str = `${str}${str.length > 0 ? "," : ""}"${key}":"${data[key]}"`;
    });
    return `{${str}}`;
  };

  printContent = (divId, title) => {
    const content = document.getElementById(divId).innerHTML;
    const printTitle = `${settings.appName.charAt(0).toUpperCase() +
      settings.appName.slice(1)} ${title}`;
    const mywindow = window.open("", printTitle, "height=600,width=800");

    mywindow.document.write(
      `<!DOCTYPE html><html><head><title>${printTitle}</title>`
    );
    mywindow.document.write(
      `<style>.no-print{display: none;} 
     </style>`
    );
    mywindow.document.write(
      `<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" />`
    );
    mywindow.document.write(
      `<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/semantic-ui@2.4.2/dist/semantic.min.css" />`
    );
    mywindow.document.write(
      `<link rel="stylesheet" type="text/css" href="/bootstrap-table-extra.css">`
    );
    mywindow.document.write(
      `<link rel="stylesheet" type="text/css" href="/App.css">`
    );
    mywindow.document.write(
      `<link rel="stylesheet" type="text/css" href="/main.css">`
    );
    mywindow.document.write(
      `<link rel="stylesheet" type="text/css" href="/print-media.css">`
    );
    mywindow.document.write(
      `<link rel="stylesheet" type="text/css" href="/sub-table.css">`
    );
    mywindow.document.write("</head><body>");
    mywindow.document.write(content);
    mywindow.document.write("</body></html>");

    mywindow.document.close();
    mywindow.focus();
    mywindow.onload = () => {
      setTimeout(() => {
        mywindow.print();
        mywindow.close();
      }, 1000);
    };
  };

  mobileViewWidth = () => {
    if (isMobile) {
      return 16;
    }
    return this.state.showSubTypes ? 11 : 16;
  };

  render() {
    const activeIndex = this.state.activeIndex;
    const { uiData, userAccount } = this.props;
    const {
      subMenuItem,
      subMenuItems,
      leftMenuItem,
      leftMenuItems,
      searchTypeIndex,
      searchLoadError,
      newFormsData,
      searchFormsData,
      errorMessage,
    } = this.state;
    let mobileView = false;
    if (subMenuItems.length < 1) {
      if (!searchLoadError || searchLoadError === null)
        return (
          <div className="container-fluid">
            <div className="col-lg-12 col-sm-12">
              <div className="row">
                <AppMenu
                  uiData={this.props.uiData}
                  userAccount={this.props.userAccount}
                  history={this.props.history}
                />
                <Segment>No records found</Segment>
              </div>
            </div>
          </div>
        );
      if (searchLoadError !== "") return <div>{searchLoadError}</div>;
      return <div>Page not found</div>;
    }

    if (isMobile) {
      mobileView = true;
    }
    const hasReport =
      leftMenuItem &&
      leftMenuItem !== null &&
      leftMenuItem.ReportIds &&
      leftMenuItem.ReportIds !== null;
    return (
      <div className="container-fluid">
        <div className="col-lg-12 col-sm-12">
          <div className="row">
            <AppMenu
              uiData={this.props.uiData}
              userAccount={this.props.userAccount}
              history={this.props.history}
            />
            <UserInterruption
              displayCancel={this.state.cancelSources.length > 0}
              handleCancelRequest={this.handleCancelRequest}
            />
            <Segment key="tabContent1" attached loading={this.state.loading}>
              <Grid stackable className="padding-left-20">
                <Grid.Row>
                  {this.state.showSubTypes ? (
                    <Grid.Column
                      className={mobileView ? "no-padding" : ""}
                      width={mobileView ? "16" : "5"}
                    >
                      {userAccount.acctTheme === 0 && activeIndex === 1 && (
                        <Table className="table-no-border-and-padding no-print">
                          <Table.Body>
                            <Table.Row>
                              <Table.Cell>
                                <SearchLeftForms
                                  newFormsData={newFormsData}
                                  submit={this.showResults}
                                  clear={this.clearFormData}
                                  previewData={this.state.previewData}
                                  searchFormsData={this.state.searchFormsData}
                                  selectedFormId={this.state.selectedFormId}
                                  onFormDataChange={this.onFormDataChange}
                                  currentMenuHierarchy={[
                                    subMenuItem && subMenuItem.MenuTitle,
                                    leftMenuItem && leftMenuItem.MenuTitle,
                                  ]}
                                  leftMenuReportId={leftMenuItem.ReportId}
                                  searchTypeIndex={searchTypeIndex}
                                  onSearchTypeChanged={this.onSearchTypeChanged}
                                  selectedSubMenu={subMenuItem}
                                  selectedLeftMenu={leftMenuItem}
                                  reports={uiData.Reports}
                                  subMenuItems={subMenuItems}
                                  leftMenuItems={leftMenuItems}
                                  history={this.props.history}
                                />
                              </Table.Cell>
                              {!mobileView && (
                                <Table.Cell className={"vertical-align-top"}>
                                  <Button
                                    onClick={this.toggleSubtype}
                                    size={"tiny"}
                                    circular
                                    className={
                                      "float-right close-left-menu-button"
                                    }
                                  >
                                    {this.state.showSubTypes ? "<" : ">"}
                                  </Button>
                                </Table.Cell>
                              )}
                            </Table.Row>
                          </Table.Body>
                        </Table>
                      )}
                      {(userAccount.acctTheme === 1 ||
                        (userAccount.acctTheme === 0 && activeIndex === 0)) && (
                          <Table className="table-no-border-and-padding no-print">
                            <Table.Body>
                              <Table.Row>
                                <Table.Cell>
                                  <SearchSubTypes
                                    searchTypeIndex={searchTypeIndex}
                                    onSearchTypeChanged={this.onSearchTypeChanged}
                                    selectedSubMenu={subMenuItem}
                                    selectedLeftMenu={leftMenuItem}
                                    reports={uiData.Reports}
                                    subMenuItems={subMenuItems}
                                    leftMenuItems={leftMenuItems}
                                    history={this.props.history}
                                    className={"float-left"}
                                    acctTheme={userAccount.acctTheme}
                                    currentReportId={this.state.currentReportId}
                                    currentReportRemainingCount={this.state.currentReportRemainingCount}
                                  />
                                </Table.Cell>
                                {!mobileView && (
                                  <Table.Cell className={"vertical-align-top"}>
                                    <Button
                                      onClick={this.toggleSubtype}
                                      size={"tiny"}
                                      circular
                                      className={
                                        "float-right close-left-menu-button"
                                      }
                                    >
                                      {this.state.showSubTypes ? "<" : ">"}
                                    </Button>
                                  </Table.Cell>
                                )}
                              </Table.Row>
                            </Table.Body>
                          </Table>
                        )}
                    </Grid.Column>
                  ) : null}

                  <Grid.Column
                    width={this.mobileViewWidth()}
                    className={mobileView ? "padding-top-20" : null}
                  >
                    <Table className={"table-no-border-and-padding"}>
                      <Table.Body>
                        <Table.Row>
                          {!(
                            userAccount.acctTheme === 0 && activeIndex === 2
                          ) &&
                            !mobileView &&
                            !this.state.showSubTypes && (
                              <Table.Cell className={"vertical-align-top"}>
                                <Button
                                  onClick={this.toggleSubtype}
                                  size={"tiny"}
                                  circular
                                  className={
                                    "float-right close-left-menu-button"
                                  }
                                >
                                  {this.state.showSubTypes ? "<" : ">"}
                                </Button>
                              </Table.Cell>
                            )}
                          <Table.Cell>
                            {userAccount.acctTheme === 1 && (
                              <Accordion
                                fluid
                                styled
                                className={"padding-top-20"}
                              >
                                <Accordion.Title
                                  active={activeIndex === 0}
                                  key={"SearchFormsTitle"}
                                  onClick={(e) => this.handleClick(e, 0)}
                                >
                                  <Icon name="dropdown" />
                                  Search
                                </Accordion.Title>
                                <Accordion.Content
                                  key="SearchForms"
                                  active={activeIndex === 0}
                                >
                                  <SearchForms
                                    newFormsData={newFormsData}
                                    submit={this.submitSearch}
                                    clear={this.clearFormData}
                                    previewData={this.state.previewData}
                                    searchFormsData={searchFormsData}
                                    acctTheme={userAccount.acctTheme}
                                    selectedFormId={this.state.selectedFormId}
                                    selectedFormIndex={
                                      this.state.selectedFormIndex
                                    }
                                    onFormDataChange={this.onFormDataChange}
                                    onFormChange={this.handleFormChange}
                                    currentMenuHierarchy={[
                                      subMenuItem && subMenuItem.MenuTitle,
                                      leftMenuItem && leftMenuItem.MenuTitle,
                                    ]}
                                    leftMenuReportId={leftMenuItem.ReportId}
                                  />
                                </Accordion.Content>
                                <Accordion.Title
                                  active={activeIndex === 1}
                                  key={"SearchResultTitle"}
                                  onClick={(e) => this.handleClick(e, 1)}
                                >
                                  <Icon name="dropdown" />
                                  Search Result
                                </Accordion.Title>
                                <Accordion.Content
                                  key={"SearchResult"}
                                  active={activeIndex === 1}
                                >
                                  {this.state.resultComponent ? (
                                    <div id="result">
                                      {this.state.resultComponent}
                                    </div>
                                  ) : (
                                    <center>
                                      {errorMessage}
                                      <br />
                                    </center>
                                  )}
                                </Accordion.Content>
                                {hasReport && (
                                  <Accordion.Title
                                    active={activeIndex === 2}
                                    key={"SearchReportTitle"}
                                    onClick={(e) => this.handleClick(e, 2)}
                                  >
                                    <Icon name="dropdown" />
                                    Report
                                  </Accordion.Title>
                                )}
                                {hasReport && (
                                  <Accordion.Content
                                    key={"SearchReport"}
                                    active={activeIndex === 2}
                                  >
                                    {this.state.reportComponent ? (
                                      this.state.reportComponent
                                    ) : (
                                      <center>
                                        {errorMessage}
                                        <br />
                                      </center>
                                    )}
                                  </Accordion.Content>
                                )}
                              </Accordion>
                            )}
                            {userAccount.acctTheme === 0 && activeIndex === 0 && (
                              <Segment>
                                <SearchForms
                                  newFormsData={newFormsData}
                                  submit={this.showResults}
                                  clear={this.clearFormData}
                                  previewData={this.state.previewData}
                                  searchFormsData={this.state.searchFormsData}
                                  acctTheme={userAccount.acctTheme}
                                  selectedFormId={this.state.selectedFormId}
                                  selectedFormIndex={
                                    this.state.selectedFormIndex
                                  }
                                  onFormDataChange={this.onFormDataChange}
                                  onFormChange={this.handleFormChange}
                                  currentMenuHierarchy={[
                                    subMenuItem && subMenuItem.MenuTitle,
                                    leftMenuItem && leftMenuItem.MenuTitle,
                                  ]}
                                  leftMenuReportId={leftMenuItem.ReportId}
                                />
                              </Segment>
                            )}
                            {userAccount.acctTheme === 0 &&
                            activeIndex === 1 &&
                            this.state.resultComponent ? (
                              <Segment>
                                <div id="result">
                                  {this.state.resultComponent}
                                </div>
                              </Segment>
                            ) : (
                              <span />
                            )}
                            {userAccount.acctTheme === 0 &&
                            activeIndex === 2 &&
                            this.state.reportComponent ? (
                              this.state.reportComponent
                            ) : (
                              <span />
                            )}
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>

            <HomeValueAndIncomeComponent
              zip={this.state.zip}
              address={this.state.address}
              showDialog={this.state.showDialog}
              handleHomeValueClose={this.handleHomeValueClose}
              homeType={this.state.homeType}
            />

            <NewSearchComponent
              searchText={this.state.searchText}
              searchData={this.state.searchData}
              dialogClose={this.handleNewSearchDialogClose}
              active={this.state.showNewSearchDialog}
              previewNewSearch={this.handlePreviewNewSearch}
              popupType={this.state.popupType}
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    uiData: state.uiData,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, {
  expireSession,
  setApiCancelSource: setApiCancelToken,
  addItemToProgress,
  removeItemFromProgress,
  clearProgressList,
})(SearchHistoryComponent);



// WEBPACK FOOTER //
// ./src/components/searches/SearchHistoryComponent.js